import { ENV } from '@config/envConfig';

/** Reads an env key from superconfig.json first, then falls back to Vite env. */
export function envValue(key: string): string | undefined {
  const fromSuperConfig = ENV[key];
  if (fromSuperConfig !== undefined && fromSuperConfig !== null && fromSuperConfig !== '') {
    return String(fromSuperConfig);
  }

  const fromVite = import.meta.env[key as keyof ImportMetaEnv];
  if (fromVite !== undefined && fromVite !== '') {
    return String(fromVite);
  }

  return undefined;
}

/** Whether the given env key resolves to the string 'true'. */
export function isTruthyEnv(key: string): boolean {
  return envValue(key) === 'true';
}
